module.exports = __webpack_public_path__ + "img/kirinsushimicroview.e9726453.jpg";